import React, { useState, useEffect } from "react";
import {
  Space,
  Typography,
  Button,
  Image,
  Card,
  Modal,
  Input,
  Form,
  ConfigProvider,
  theme,
  Tooltip,
} from "antd";
import { useUserContext, Statescontex } from "../../context/index.js";
import {
  subscribeUser,
  unsubscribeUser,
  handleUpdateDetails,
} from "../../services/apicall.tsx";
import { Link, Navigate } from "react-router-dom";
import { Logout, ReferralCard } from "../../components/index.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCashRegister,
  faGift,
  faPencil,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";

import SubscriptionModal from "./sub.tsx";
import { colors } from "../../devdata/constants/themes.js";

const { Title, Text } = Typography;
const images = [
  "https://cdn.builder.io/api/v1/image/assets/TEMP/fd5b15ee5bf5b4c87c1b371112e2062f7f83543ca9ed5b36f3d8bee83836e53c?placeholderIfAbsent=true&apiKey=aad7a7097547481c93a386421ef45bec",
  "https://wallpapers.com/images/featured/cartoon-animal-pictures-4bbi9663xvz1r0as.jpg",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJi4GVrwQiN6npdfURgadzauaeIxY0-kMOpQ&s",
  "https://img.freepik.com/premium-photo/owl-logo-with-dark-background-yellow-black-owl-generative-ai_958108-69028.jpg",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2icRVaZ29AjL2kDY_hiKfX_qAZ5iXGrXKj_63T8ENQEtrlKbOB6EvGwfTwBpsbwRIFq8&usqp=CAU", // // Add more images as needed
  "https://cdn.prod.website-files.com/67c9e6a6a2e7388a9d522cc2/67c9e6a6a2e7388a9d523265_profile%20aesthetics%20ICON.png",
  "https://i.pinimg.com/474x/d4/ef/87/d4ef87fc23ade1d6d97a4002b65e1b0e.jpg",
  "https://i.pinimg.com/736x/6a/f0/be/6af0bead8ff48ea0a5397108e259ad55.jpg",
  "https://img.freepik.com/premium-vector/cute-bear-cartoon-character-vector-icon-illustration-animal-nature-icon-concept-isolated-premium-vector-flat_766625-1.jpg?w=740",
  "https://img.freepik.com/free-vector/cute-robot-holding-phone-with-laptop-cartoon-vector-icon-illustration-science-technology-isolated_138676-4870.jpg?t=st=1743688474~exp=1743692074~hmac=301bdd412f42024ad24d57fa73ddf37d87b58a60e3729a85089ecfb6adf1c553&w=740",
  "https://www.freepik.com/free-vector/astronaut-floating-with-balloons-cartoon-vector-icon-illustration-science-technology-icon-concept-isolated-premium-vector-flat-cartoon-style_16704005.htm",
  "https://img.freepik.com/free-vector/astronaut-riding-rocket-with-peace-hand-cartoon-vector-icon-illustration-science-technology-icon-concept-isolated-premium-vector-flat-cartoon-style_138676-3496.jpg?t=st=1743688447~exp=1743692047~hmac=2883bc7e617635991cd4333fc4712ac8f1c90640ab770ebee3596aa3c0b61a07&w=740",
];

function ProfilePage() {
  const [loading, setLoading] = useState(false);
  const [showPlans, setShowPlans] = useState(false);
  const [showcode, setshowcode] = useState(false);
  const [showref, setshowref] = useState(false);
  const { setErrorshow, setErrorMessage } = Statescontex();
  const { userToken, userdetails, sub, setsub, setuser } = useUserContext();
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [form] = Form.useForm();
  const referralLink = `https://marketpulse.exchange/signup?refcode=${userdetails?.referralCode}`;
  // When the modal opens or when userdetails change, update the form fields.
  useEffect(() => {
    if (editModalVisible && userdetails) {
      form.setFieldsValue({
        ...userdetails,

      });
    }
  }, [editModalVisible, userdetails, form]);

  const handleEditDetails = () => {
    // No need to call form.setFieldsValue here since the useEffect does that.
    setEditModalVisible(true);
  };

  const handleUpdateDetail = () => {
    handleUpdateDetails(
      userToken,
      form,
      setuser,
      setLoading,
      setEditModalVisible,
      setErrorMessage,
      setErrorshow
    );
  };

  if (!userdetails) {
    return <Navigate to={"/"} />;
  }
  return (
    <div className="flex flex-col bg-darkMode-background p-4 md:p-6 min-h-screen">
      <div className="flex flex-wrap gap-6 items-start w-full">
        <div className="flex flex-col pb-4 md:pb-10 rounded-xl w-full">
          <div className="flex items-center gap-1 text-xl md:text-2xl font-semibold text-darkMode-text px-4 md:px-0">
            <h1 className="text-4xl md:text-5xl font-bold mb-2">
              My <span className="text-market-teal">Profile</span>
            </h1>
          </div>
          <Text className="text-sm text-darkMode-subText px-4 md:px-0">
            {/* Personal and Account Details */}
          </Text>
        </div>

        <div className="flex flex-col pb-10 mt-6 w-full items-center">
          <div className="flex flex-col items-center font-medium w-full">
            <Image
              preview={false}
              src={images[userdetails.name.length % images.length]}
              alt="Profile Picture"
              className="object-contain max-w-full rounded-full"
              width={200}
              height={200}
              style={{ width: "200px", height: "200px" }}
            />
            <div className="mt-2 text-xl md:text-2xl text-darkMode-text text-center">
              {userdetails.name}
            </div>
            {userdetails.isverified === true ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 justify-center sm:justify-between items-center mt-4">
                <Link
                  to="/Subscriptions"
                  className="bg-darkMode-green hover:text-black  hover:bg-darkMode-green/80 mt-2 text-center px-5 py-3 border-none text-darkMode-background rounded-full text-sm md:text-base transition-all duration-300"
                >
                  <p className="">View Plans</p>
                </Link>

                <button
                  className="flex flex-row items-center mt-2 bg-gray-800 hover:bg-gray-700 px-5 py-3 text-darkMode-subText hover:text-white border-none rounded-full text-sm md:text-base transition-all duration-300"
                  onClick={() => {
                    setshowcode(true);
                  }}
                // onMouseEnter={() => {
                //   setshowref(true);
                // }}
                // onMouseLeave={() => {
                //   setshowref(false);
                // }}
                >
                  {showref ? (
                    <p className="text-darkMode-subText ml-2 px-7">
                      {userdetails?.referralCode}
                    </p>
                  ) : (
                    <>
                      <img
                        src={require("../../devdata/icons/earn.png")}
                        className="mr-1 h-5 w-auto"
                        alt="earn"
                      />
                      <span>Refer & Earn</span>
                    </>
                  )}
                </button>
              </div>
            ) : (
              <button
                className="mt-2 bg-darkMode-green px-5 py-2.5 border-none text-darkMode-background rounded-full hover:text-black text-sm md:text-base transition-all duration-300"
                onClick={() => (window.location.href = "/verify")}
              >
                Verify to Subscribe
              </button>
            )}
          </div>

          <div className="flex flex-col md:flex-row gap-4 md:gap-8 mt-6 px-0 md:px-6 w-full">
            <div className="flex flex-col p-4 rounded-xl bg-darkMode-layer1 text-darkMode-text w-full md:w-1/2">
              <div className="flex items-center justify-between">
                <div className="text-xl font-semibold text-darkMode-subText">
                  <span>Personal Details</span>
                </div>
                <div className="flex items-center">
                  <button
                    className="text-darkMode-subText hover:text-darkMode-green text-sm flex-row flex items-center transition-all duration-300"
                    onClick={handleEditDetails}
                  >
                    <FontAwesomeIcon icon={faPencil} className="mr-1" />
                    <span>Edit</span>
                  </button>
                </div>
              </div>
              <div className="mt-4 text-sm">
                {[
                  { label: "Name", value: userdetails.name },
                  {
                    label: "Birth Date",
                    value: userdetails.birthDate || "Not Set",
                  },
                ].map((item, index) => (
                  <div key={index} className="flex mt-2 justify-between py-1">
                    <div className="font-semibold">{item.label}</div>
                    <div className="">{item.value}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col p-4 rounded-xl bg-darkMode-layer1 text-darkMode-text w-full md:w-1/2">
              <div className="flex items-center justify-between">
                <div className="text-xl font-semibold text-darkMode-subText">
                  <span>Account Details</span>
                </div>
                <div className="text-lg cursor-pointer text-right text-darkMode-red0 hover:text-darkMode-red font-thin">
                  <span>Remove account</span>
                </div>
              </div>
              <div className="mt-4 text-sm">
                {[
                  { label: "Email", value: userdetails.username },
                  { label: "Mobile Number", value: userdetails.phone },
                  ...(userdetails.subscription !== "none"
                    ? [
                      { label: "Subscription", value: userdetails.subscription },
                      {
                        label: "Expiry", value: new Date(userdetails.subexp).toLocaleDateString(
                          "en-GB"
                        )
                      },
                    ]
                    : []),
                ].map((item, index) => (
                  <div key={index} className="flex mt-2 justify-between py-1">
                    <div className="font-semibold">{item.label}</div>
                    <div>{item.value}</div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>
      </div>
      <SubscriptionModal
        showPlans={showPlans}
        setShowPlans={setShowPlans}
        currentSubscription={sub}
        loading={loading}
        setLoading={setLoading}
        setsub={setsub}
        setErrorMessage={setErrorMessage}
        setError={setErrorshow}
      />
      <ReferralCard showModal={showcode} setShowModal={setshowcode} />
      <ConfigProvider
        theme={{
          token: {
            colorBgContainer: colors.darkMode.layer2,
          },
          algorithm: theme.darkAlgorithm,
        }}
      >
        <Modal
          title={
            <span className="text-darkMode-text">Edit Personal Details</span>
          }
          open={editModalVisible}
          onCancel={() => setEditModalVisible(false)}
          onOk={handleUpdateDetail}
          confirmLoading={loading}
          className="rounded-xl shadow-lg text-darkMode-text"
          contentClassName="bg-darkMode-layer2 rounded-md p-6"
          okButtonProps={{
            className:
              "bg-darkMode-green hover:bg-darkMode-green-dark text-darkMode-layer1 border-none rounded-md shadow-md",
          }}
          cancelButtonProps={{
            className:
              "bg-darkMode-layer3 hover:bg-darkMode-layer2 text-darkMode-text border-none rounded-md shadow-md",
          }}
        >
          <Form
            form={form}
            layout="vertical"
            initialValues={userdetails}
            className="text-darkMode-text"
          >
            <Form.Item
              label={<span className="text-darkMode-text">Birth Date</span>}
              name="birthDate"
              className="mb-4"
            >
              <Input
                type="date"
                placeholder="Enter birth date"
                className="bg-darkMode-layer3 text-darkMode-text rounded-md border border-darkMode-layer3 focus:outline-none focus:ring-2 focus:ring-darkMode-green shadow-sm"
              />
            </Form.Item>

          </Form>
        </Modal>
      </ConfigProvider>
    </div>
  );
}

export default ProfilePage;
